module.exports = __webpack_public_path__ + "69aaf9011b08076b5b00e517f5837ca2.svg";